import Vue from 'vue'
import VueParallaxJs from 'vue-parallax-js'

import router from '@/router'

Vue.use(VueParallaxJs)

router.afterEach((to, from) => {
  if (to.meta.name !== from.meta.name) {
    router.app.$parallaxjs.items = []
  }
})



// WEBPACK FOOTER //
// ./src/plugins/parallax.js